import { createSlice } from "@reduxjs/toolkit";

const windowSlice = createSlice({
  name: "window",
  initialState: {
    size: {
      screenWidth: null,
      screenHeight: null,
      showHeader: false,
    },
    showHeader: true,
    showMenu: false,
    toolsExpanded: false,
  },
  reducers: {
    setWindowSize(state, action) {
      state.size = action.payload;
    },
    setShowMenu(state, action) {
      state.showMenu = action.payload;
    },
    setExpandToolsMenu(state, action) {
      state.toolsExpanded = action.payload;
    },
    setShowHeader(state, action) {
      state.showHeader = action.payload;
    },
  },
});

export const { setWindowSize, setShowMenu, setShowHeader, setExpandToolsMenu } =
  windowSlice.actions;
export default windowSlice.reducer;
